import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { SpsAutocompleteComponent } from "../components/index";
import { SpsOptionListModule } from "./sps-option-list.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SpsOptionListModule,
    ],
    declarations: [SpsAutocompleteComponent],
    exports: [SpsAutocompleteComponent]
})
export class SpsAutocompleteModule {}
